export const PROVINCES = [
  { code: 'AB', label: { es: 'Alberta', en: 'Alberta', fr: 'Alberta' } },
  { code: 'BC', label: { es: 'Columbia Británica', en: 'British Columbia', fr: 'Colombie-Britannique' } },
  { code: 'MB', label: { es: 'Manitoba', en: 'Manitoba', fr: 'Manitoba' } },
  { code: 'NB', label: { es: 'Nuevo Brunswick', en: 'New Brunswick', fr: 'Nouveau-Brunswick' } },
  { code: 'NL', label: { es: 'Terranova y Labrador', en: 'Newfoundland and Labrador', fr: 'Terre-Neuve-et-Labrador' } },
  { code: 'NS', label: { es: 'Nueva Escocia', en: 'Nova Scotia', fr: 'Nouvelle-Écosse' } },
  { code: 'NT', label: { es: 'Territorios del Noroeste', en: 'Northwest Territories', fr: 'Territoires du Nord-Ouest' } },
  { code: 'NU', label: { es: 'Nunavut', en: 'Nunavut', fr: 'Nunavut' } },
  { code: 'ON', label: { es: 'Ontario', en: 'Ontario', fr: 'Ontario' } },
  { code: 'PE', label: { es: 'Isla del Príncipe Eduardo', en: 'Prince Edward Island', fr: 'Île-du-Prince-Édouard' } },
  { code: 'QC', label: { es: 'Quebec', en: 'Quebec', fr: 'Québec' } },
  { code: 'SK', label: { es: 'Saskatchewan', en: 'Saskatchewan', fr: 'Saskatchewan' } },
  { code: 'YT', label: { es: 'Yukón', en: 'Yukon', fr: 'Yukon' } },
];
